import React, { useEffect, useState } from 'react';
import './tradingBotChainsSection.scss';
import { ReactComponent as TradingBotLogo_1 } from "./icons/TradingBotLogo_1.svg";
import { ReactComponent as TradingBotLogo_2 } from "./icons/TradingBotLogo_2.svg";
import { ReactComponent as TradingBotLogo_3 } from "./icons/TradingBotLogo_3.svg";
import { ReactComponent as TradingBotLogo_4 } from "./icons/TradingBotLogo_4.svg";
import { ReactComponent as TradingBotLogo_5 } from "./icons/TradingBotLogo_5.svg";
import { ReactComponent as TradingBotLogo_6 } from "./icons/TradingBotLogo_6.svg";
import TradingBotChainsItemComponent from "./components/TradingBotChainsItemComponent";
import Slider from "react-slick";

const TradingBotChainsSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: width < 1023 ? width < 768 ? 1 : 2 : 3,
		slidesToScroll: 1,
		swipeToSlide: true,
		focusOnSelect: true,
		variableWidth: true,
		centerMode: false,
		arrows: false,
		className: "tradingBotChains__content_icons_row_slider"
	};
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="tradingBotChains">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="tradingBotChains__content">
				<div className="tradingBotChains__content_data">
					<div className="tradingBotChains__content_data_title">
						<h2>Trading Bot Chains</h2>
						<span>NFD Bot logos are displayed in the official colors and different chains</span>
					</div>
					<div className="tradingBotChains__content_data_button">
						<button
							className="secondButton"
							onClick={() => {}}
						>
							<span>Download All Banners</span>
						</button>
					</div>
					<div className="stars"></div>
					<div className="stars2"></div>
					<div className="stars3"></div>
				</div>
				
				<div className="tradingBotChains__content_icons">
					<div className="tradingBotChains__content_icons_row first">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<Slider {...settings}>
							<TradingBotChainsItemComponent icon={<TradingBotLogo_1 />} color={'purple'} />
							<TradingBotChainsItemComponent icon={<TradingBotLogo_2 />} color={'purple'} />
							<TradingBotChainsItemComponent icon={<TradingBotLogo_3 />} color={'purple'} />
						</Slider>
					</div>
					<div className="tradingBotChains__content_icons_row second">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<Slider {...settings}>
							<TradingBotChainsItemComponent icon={<TradingBotLogo_4 />} color={'purple'} />
							<TradingBotChainsItemComponent icon={<TradingBotLogo_5 />} color={'purple'} />
							<TradingBotChainsItemComponent icon={<TradingBotLogo_6 />} color={'purple'} />
						</Slider>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TradingBotChainsSection;